var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2CoreSpeakerCable01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 8,
    x2: 3,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.1,
    y1: 8,
    x2: 3.5,
    y2: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.7,8 4.3,8 4.5,8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.7,
    y1: 8,
    x2: 5.3,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,8H6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.9,
    y1: 8,
    x2: 7.4,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.6,
    y1: 8,
    x2: 8.2,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.5,
    y1: 8,
    x2: 9,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.2,
    y1: 8,
    x2: 9.7,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 8,
    x2: 10.5,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.2,
    y1: 8,
    x2: 6.8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.7,
    y1: 8,
    x2: 11.2,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.5,
    y1: 8,
    x2: 12.1,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.3,
    y1: 8,
    x2: 12.8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 8,
    x2: 13.5,
    y2: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2CoreSpeakerCable01);
export default __webpack_public_path__ + "static/media/2CoreSpeakerCable-01.e7c943ae696b739d528a75cd9511e783.svg";
export { ForwardRef as ReactComponent };